import type { SalesSnapshot } from '../../types/domain';

export const seedSales = (businessId: string): SalesSnapshot => {
  const timestamp = new Date().toISOString();
  const isDemoRestaurant = businessId === 'biz_casa_norte';
  const isDemoServices = businessId === 'biz_taller_norte';
  return {
    businessId,
    customers: isDemoRestaurant ? [
      { id: 'cus_ana_mtz', businessId, name: 'Ana Martínez', phone: '899 122 3344', whatsapp: '528991223344', email: 'ana@example.test', address: 'Col. Las Fuentes', notes: 'Prefiere recolección.', creditLimitCents: 300000, balanceCents: 0, createdAt: timestamp, updatedAt: timestamp },
      { id: 'cus_carlos_ruiz', businessId, name: 'Carlos Ruiz', phone: '899 455 6677', whatsapp: '528994556677', email: '', address: '', notes: '', creditLimitCents: 150000, balanceCents: 0, createdAt: timestamp, updatedAt: timestamp },
    ] : isDemoServices ? [
      { id: 'cus_maria_demo', businessId, name: 'María González', phone: '899 333 1122', whatsapp: '528993331122', email: 'maria@example.test', address: '', notes: 'Solicita comprobante por WhatsApp.', creditLimitCents: 0, balanceCents: 0, createdAt: timestamp, updatedAt: timestamp },
    ] : [],
    sales: [],
    cashSessions: isDemoRestaurant ? [{ id: 'cash_demo_centro', businessId, branchId: 'br_centro', registerName: 'Caja principal', openedBy: 'usr_demo_owner', openedAt: timestamp, openingFloatCents: 100000, status: 'open' }] : [],
    cashMovements: [],
    suspendedCarts: [],
    publicOrders: [],
  };
};
